// Override forwardRef types so that generic components retain their generics.

import {
  // eslint-disable-next-line no-restricted-imports
  forwardRef as originalForwardRef,
  type Ref,
  type RefAttributes,
  type JSX,
} from 'react';

/*
In order for generic components to retain their generics,
`forwardRef` must return a simple function.
We cannot therefore expose `displayName` as a property on the return type.
As a workaround, our `forwardRef` accepts a `displayName` parameter and sets it on the component internally.
*/
export function forwardRef<T, R>(
  Component: (props: T, ref: Ref<R>) => JSX.Element | null,
  displayName?: string,
): (props: T & RefAttributes<R>) => JSX.Element | null {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const WrappedComponent = originalForwardRef(Component as any);

  // @ts-expect-error missing type definition for displayName
  const existingDisplayName = Component.displayName || Component.name || 'Component';
  WrappedComponent.displayName = displayName || `ForwardRef(${existingDisplayName})`;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return WrappedComponent as any;
}
